"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFeedbackMessage = void 0;
var setFeedbackMessage = function (_, _a, _b) {
    var message = _a.message, isError = _a.isError, autoclose = _a.autoclose;
    var cache = _b.cache;
    cache.writeData({
        data: {
            feedbackMessage: {
                __typename: "feedbackMessage",
                message: message,
                isError: isError,
                autoclose: autoclose,
            },
        },
    });
};
exports.setFeedbackMessage = setFeedbackMessage;
//# sourceMappingURL=feedback-message.js.map